/*
$(document).ready(function () {

  if ($(window).innerWidth() >= 990) {
    // Show more/less click event for default product template start 
    var $desc = $(".product__description");
    var fullHeight = $desc.prop("scrollHeight");
    var collapsedHeight = 50; // pixels

    // Set initial collapsed height
    $desc.css("height", collapsedHeight + "px");
    $(".toggle-description").show();

    $(".toggle-description").click(function () {
      if ($desc.hasClass("expanded")) {
        // Collapse
        $desc.animate({ height: collapsedHeight + "px" }, 400);
        $(this).find('span').text("Show more");
      } else {
        // Expand to full content height
        $desc.animate({ height: fullHeight + "px" }, 400);
        $(this).find('span').text("Show less");
      }

      $desc.toggleClass("expanded");
    });
    // Show more/less click event for default product template end 
  }

});
*/


// upsell block
document.addEventListener("DOMContentLoaded", () => {
  function plusBundle(qty1, id1, qty2, id2, prop1, prop2) {
    // Initialize items array with first item
    const items = [
      {
        quantity: qty1,
        id: id1,
        properties: prop1
      }
    ];

    // Conditionally add second item only if qty2 and id2 are valid
    if (qty2 && id2) {
      items.push({
        quantity: qty2,
        id: id2,
        properties: prop2
      });
    }

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const sections = document
      .querySelector('cart-drawer')
      ?.getSectionsToRender()
      .map((section) => section.id);

    const addToCartRTY = (item) => {
      const formData = {
        quantity: item.quantity,
        id: item.id,
        sections: sections,
        sections_url: window.location.pathname,
      };

      if (item.properties && Object.keys(item.properties).length > 0) {
        formData.properties = item.properties;
      }

      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error adding item to cart:', error);
          throw error;
        });
    };

    const addAllItems = () => {
      let promiseChain = Promise.resolve();
      let lastResponseData = null;

      items.forEach((item) => {
        promiseChain = promiseChain.then(() => {
          return addToCartRTY(item).then((data) => {
            lastResponseData = data; // Capture latest response to render cart
          });
        });
      });

      promiseChain
        .then(() => {
          if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart?.renderContents(lastResponseData);
          console.log('Final cart data:', lastResponseData);
        })
        .catch((error) => {
          console.error('Error adding multiple items to cart:', error);
        })
        .finally(() => {
          if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    };

    addAllItems();
  }


  // single product with dynamic quantity
  let atcButton = document.querySelector('.us-atc-btn');
  if (atcButton) {
    atcButton.addEventListener('click', function(e) {
      e.preventDefault();
      let form = this.closest('form');
      let ID1 = Number(form.querySelector('input[name="id"]').value);
      let qty1 = Number(this.getAttribute('data-quantity1'));
      let up1Prop = {
        "What's Included": this.getAttribute('data-up1-prop')
      };

      plusBundle(qty1, ID1, null, null, up1Prop, null);

    });
  }
  // single product with dynamic quantity


  // single upsell but double product
  let dpAtcButton = document.querySelector('.us-atc-dp-btn');
  if (dpAtcButton) {
    dpAtcButton.addEventListener('click', function(e) {
      e.preventDefault();
      let ID1 = document.querySelector('.upsell-1 .product-form__controls-group input:checked')?.getAttribute("data-variant-id");
      let ID2 = document.querySelector('.upsell-2 .product-form__controls-group input:checked')?.getAttribute("data-variant-id");
      let qty1 = Number(this.getAttribute('data-quantity1') || 1);
      let qty2 = Number(this.getAttribute('data-quantity2') || 1);
      let up1Prop = {
        "What's Included": this.getAttribute('data-up1-prop')
      };
      let up2Prop = {
        "What's Included": this.getAttribute('data-up2-prop')
      };
      plusBundle(qty1, ID1, qty2, ID2, up1Prop, up2Prop);

    });
  }
  // single upsell but double product






  // image mapping on variant changes start
  
  


  let navProductSlider = document.querySelector('.js-media-list')?.swiper;
  let thumbnailProductSlider = document.querySelector('.js-media-sublist')?.swiper;

  // Cache all slides data on init
  const allMainSlides = [...document.querySelectorAll('.product__media-list .swiper-slide')].map(slide => slide.outerHTML);
  const allThumbSlides = [...document.querySelectorAll('.product__media-sublist-container .swiper-slide')].map(slide => slide.outerHTML);
  const allPopupSlides = [...document.querySelectorAll('.js-popup-slider .swiper-slide')].map((slide) => slide.outerHTML);

  // Helper to get data-alt attribute from slide html string
  function getDataAltFromHtml(htmlString) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return (tempDiv.querySelector('.swiper-slide').getAttribute('data-alt') ?? '').trim().toLowerCase();}

  
  function filterSlides(currentFilterAttribute) {
    // Clear DOM directly — removeAllSlides() leaves ghost elements in swiper-wrapper
    navProductSlider.wrapperEl.innerHTML = '';
    thumbnailProductSlider.wrapperEl.innerHTML = '';

    // Filter main slides based on data-alt
    const filteredMainSlides = allMainSlides.filter(html => {
      const val = getDataAltFromHtml(html);
      return !val || val === currentFilterAttribute;
    });

    // Filter thumbnail slides similarly
    const filteredThumbSlides = allThumbSlides.filter(html => {
      const val = getDataAltFromHtml(html);
      return !val || val === currentFilterAttribute;
    });

    const mainSlidesToUse = filteredMainSlides.length > 0 ? filteredMainSlides : allMainSlides;
    const thumbSlidesToUse = filteredThumbSlides.length > 0 ? filteredThumbSlides : allThumbSlides;

    // Append filtered or default slides to sliders
    navProductSlider.appendSlide(mainSlidesToUse);
    thumbnailProductSlider.appendSlide(thumbSlidesToUse);


    // Update both sliders and sync if necessary
    navProductSlider.update();
    thumbnailProductSlider.update();


    // Optionally reset to first slide after filtering
    navProductSlider.slideTo(0);
    thumbnailProductSlider.slideTo(0);

    setTimeout(() => {
      thumbnailProductSlider.slides.forEach(tb => tb.removeAttribute('style'));
      thumbnailProductSlider.update();
    }, 50);
    
    // Rebuild popup (modal) swiper to match variant
    const popupSwiper = document.querySelector('.js-popup-slider')?.swiper;
    if (popupSwiper && allPopupSlides.length) {
      const filteredPopupSlides = allPopupSlides.filter((html) => {
        const alt = getDataAltFromHtml(html);
        return !alt || alt === currentFilterAttribute;
      });
      const popupSlidesToUse = filteredPopupSlides.length
        ? filteredPopupSlides
        : allPopupSlides;
      popupSwiper.removeAllSlides();
      popupSwiper.appendSlide(popupSlidesToUse);
      popupSwiper.update();
      popupSwiper.slideTo(0, 0);
    }
  }
  
 



  // Bind inputs
  document.querySelectorAll('.color-product-variant input').forEach(input => {
    input.addEventListener('change', () => {
      

      const filter = input.value.trim().toLowerCase();
      if (input.value && input.value.length > 0) {
        filterSlides(filter);
      }
    });
  });


  if (document.querySelector('.color-product-variant input:checked')) {
    let selectedVariant = document.querySelector('.color-product-variant input:checked');
    const selectedVariantFilter = selectedVariant.value.trim().toLowerCase();
    filterSlides(selectedVariantFilter);
  }

  // image mapping on variant changes end



  /*
  // add replace variants start
  let cartReplaceBtn = document.querySelector('.cartReplaceItems');

  if (cartReplaceBtn) {
    cartReplaceBtn.addEventListener('click', function(e) {
      e.preventDefault();
      let originalID = Number(this.getAttribute('data-original-item-id'));
      let offeredVariantID = Number(document.querySelector('.suggestion-product-variants .product-form__controls-group input:checked').getAttribute('data-variant-id'));
      replaceItems(originalID, offeredVariantID)
      console.log('add to cart is clicking', originalID, offeredVariantID);
    })
  }

  function replaceItems(originalID, replaceID) {
    let updates = {
      [originalID]: 0,
      [replaceID]: 1
    };

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const sections = document
      .querySelector('cart-drawer')
      ?.getSectionsToRender()
      .map((section) => section.id);

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        updates,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
    .then(response => response.json())
    .then(data => {
      if (cart?.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
      cart?.renderContents(data);
      console.log('Cart updated:', data);
    })
    .catch((error) => {
      console.error('Error updating cart:', error);
    })
    .finally(() => {
      if (cart?.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    });
  }
  // add replace variants end
  */

  // final proper JS start
  // GA4 / Tracklution tracking for cart drawer bundle upgrades.
  // Flow 1: Fizz Kit -> Fizz Bundle  => event "fizz_kit_to_fizz_bundle"
  // Flow 2: Fizz Bundle -> Maxi Bundle => event "fizz_bundle_to_maxi_bundle"
  // Extra params (from_product/to_product/variant_id/currency) let GTM/Tracklution custom event
  // tags pull richer context via dataLayer variables instead of just the bare event name.
  function trackBundleUpgrade(triggerEl, variantId) {
    if (!triggerEl) return;

    const from = (triggerEl.getAttribute('data-upgrade-from') || '').trim();
    const to = (triggerEl.getAttribute('data-upgrade-to') || '').trim();

    const eventMap = {
      'fizz-kit>fizz-bundle': 'fizz_kit_to_fizz_bundle',
      'fizz-bundle>maxi-bundle': 'fizz_bundle_to_maxi_bundle'
    };
    const eventName = eventMap[from + '>' + to];
    if (!eventName) return;

    const eventParams = {
      from_product: from || undefined,
      to_product: to || undefined,
      variant_id: variantId || undefined,
      currency: window.Shopify?.currency?.active || undefined
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventParams });

    // Send the event straight to the GA4 property via gtag.
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParams);
    }

    // Send the event straight to Tracklution via its tlq() SDK (installed in theme.liquid).
    if (typeof window.tlq === 'function') {
      window.tlq('track', eventName, eventParams);
    }
  }

  // GA4 / Tracklution tracking for PDP bundle upgrade & downgrade upsells
  // (main-product.liquid metaobject block, popup-bottles snippet, product-card-complementary snippet).
  // Flow 1: Fizz Kit -> Fizz Bundle    => event "fizz_kit_to_fizz_bundle_pdp"
  // Flow 2: Fizz Bundle -> Maxi Bundle => event "fizz_bundle_to_maxi_bundle_pdp"
  // Flow 3: Maxi Bundle -> Fizz Kit    => event "maxi_bundle_to_fizz_kit_pdp"
  const pdpBundleEventLabels = {
    fizz_kit_to_fizz_bundle_pdp: { from: 'fizz-kit', to: 'fizz-bundle' },
    fizz_bundle_to_maxi_bundle_pdp: { from: 'fizz-bundle', to: 'maxi-bundle' },
    maxi_bundle_to_fizz_kit_pdp: { from: 'maxi-bundle', to: 'fizz-kit' }
  };

  function trackPdpBundleUpgrade(eventName, variantId) {
    if (!eventName) return;

    const labels = pdpBundleEventLabels[eventName] || {};
    const eventParams = {
      from_product: labels.from,
      to_product: labels.to,
      variant_id: variantId || undefined,
      currency: window.Shopify?.currency?.active || undefined
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventParams });

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParams);
    }

    // Send the event straight to Tracklution via its tlq() SDK (installed in theme.liquid).
    if (typeof window.tlq === 'function') {
      window.tlq('track', eventName, eventParams);
    }
  }

  document.addEventListener('click', function(e) {
    const gtmEventBtn = e.target.closest('[data-gtm-event]');
    if (gtmEventBtn) {
      const eventName = gtmEventBtn.getAttribute('data-gtm-event');
      const variantId = gtmEventBtn.closest('form')?.querySelector('input[name="id"]')?.value;
      trackPdpBundleUpgrade(eventName, variantId);
    }
  });

  // Event delegation: handle clicks on dynamically replaced cart drawer buttons
document.addEventListener('click', function(e) {
  // Check if the clicked element or its parent has the class 'cartReplaceItems'
  const replaceBtn = e.target.closest('.cartReplaceItems');
  const cartAddBtn = e.target.closest('.cartAdditem');

  if (cartAddBtn) {
    e.preventDefault();
    const originalID = Number(cartAddBtn.getAttribute('data-original-item-id'));
    const offeredInput = document.querySelector('.suggestion-product-variants .product-form__controls-group input:checked');
    if (!offeredInput) {
      console.warn('No variant selected');
      return;
    }
    const offeredVariantID = Number(offeredInput.getAttribute('data-variant-id'));
    trackBundleUpgrade(cartAddBtn, offeredVariantID);
    plusBundle(1, offeredVariantID);
  }

  if (replaceBtn) {
    e.preventDefault();

    const originalID = Number(replaceBtn.getAttribute('data-original-item-id'));

    const offeredInput = document.querySelector('.suggestion-product-variants .product-form__controls-group input:checked');
    const offeredInput2 = document.querySelector('.suggestion-product-variants-2 .product-form__controls-group input:checked');

    let bottle1 = Number(document.querySelector('.cart-drawer-popup .bottle-1 .radio-color-swatch input:checked')?.getAttribute('data-variant-id'));
    let bottle2 = Number(document.querySelector('.cart-drawer-popup .bottle-2 .radio-color-swatch input:checked')?.getAttribute('data-variant-id'));
    let bottle3 = Number(document.querySelector('.cart-drawer-popup .bottle-3 .radio-color-swatch input:checked')?.getAttribute('data-variant-id'));

    let bottleColor1 = document.querySelector('.cart-drawer-popup .bottle-1 .radio-color-swatch input:checked')?.getAttribute('value');
    let bottleColor2 = document.querySelector('.cart-drawer-popup .bottle-2 .radio-color-swatch input:checked')?.getAttribute('value');
    let bottleColor3 = document.querySelector('.cart-drawer-popup .bottle-3 .radio-color-swatch input:checked')?.getAttribute('value');


    // Swatches can be hidden by the metaobject (hide_swatches): fall back to the default variant of the upsell form
    const offeredForm = replaceBtn.closest('form');
    const offeredFormIdInput = offeredForm?.querySelector('input[name="id"]');

    if (!offeredInput && !offeredFormIdInput) {
      console.warn('No variant selected');
      return;
    }

    const offeredVariantID = Number(offeredInput ? offeredInput.getAttribute('data-variant-id') : offeredFormIdInput.value);
    const offeredVariantProp = {
      "What's Included": offeredInput
        ? offeredInput.getAttribute('data-item-property')
        : offeredForm.querySelector('input[name="properties[What\'s Included]"]')?.value
    };

    // Bottle colours from the cart popup (Maxi Bundle: 3, Fizz Bundle: 1), bottles missing in the popup are skipped
    [[bottle1, bottleColor1], [bottle2, bottleColor2], [bottle3, bottleColor3]].forEach(([bottleId, bottleColor], index) => {
      if (!bottleId) return;
      offeredVariantProp[`_Bottle Color ${index + 1}`] = String(bottleId);
      offeredVariantProp[`Bottle Color ${index + 1}`] = bottleColor;
    });

    let offeredVariantID2 = null;
    let qty2 = null;
    let offeredVariantProp2 = null;

    if (offeredInput2) {
      offeredVariantID2 = Number(offeredInput2.getAttribute('data-variant-id'));

      const qty2Attr = document.querySelector('.suggestion-product-variants-2')?.getAttribute('data-qty2');
      qty2 = qty2Attr ? Number(qty2Attr) : 1;

      offeredVariantProp2 = {
        "What's Included": offeredInput2.getAttribute('data-item-property')
      };
    }

    document.body.classList.remove('model-active');
    trackBundleUpgrade(replaceBtn, offeredVariantID);
    // Only pass 2nd product if it exists
    if (offeredVariantID2 && qty2) {
      replaceItems(originalID, offeredVariantID, offeredVariantID2, qty2, offeredVariantProp, offeredVariantProp2);
    } else {
      replaceItems(originalID, offeredVariantID, null, null, offeredVariantProp);
    }

    console.log('Replace button clicked:', originalID, offeredVariantID, offeredVariantID2, qty2);
  }
});

// Function to replace one cart item with another
/*
function replaceItems(originalID, replaceID, productID2, qty2) {
  let updates = {
    [originalID]: 0,  // Remove original item
    [replaceID]: 1    // Add replacement variant
  };

  // Only add productID2 and qty2 if they are provided
  if (productID2 !== undefined && qty2 !== undefined) {
    updates[productID2] = qty2;
  }

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const sections = document
    .querySelector('cart-drawer')
    ?.getSectionsToRender()
    .map((section) => section.id);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ 
      updates,
      sections,
      sections_url: window.location.pathname
    })
  })
  .then(response => response.json())
  .then(data => {
    // Re-render the cart drawer with updated contents
    if (cart?.classList.contains('is-empty')) {
      cart.classList.remove('is-empty');
    }

    cart?.renderContents(data);
    console.log('Cart updated:', data);
  })
  .catch((error) => {
    console.error('Error updating cart:', error);
  })
  .finally(() => {
    if (cart?.classList.contains('is-empty')) {
      cart.classList.remove('is-empty');
    }
  });
}
*/

// new add.js + update.js start
function replaceItems(originalID, replaceID, productID2 = null, qty2 = null, properties1 = {}, properties2 = {}) {
  let updates = {
    [originalID]: 0,
  };

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const sections = document
    .querySelector('cart-drawer')
    ?.getSectionsToRender()
    .map((section) => section.id);

  // Step 1 — remove original item
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      updates: { [originalID]: 0 },
      sections,
      sections_url: window.location.pathname
    })
  })
  .then(res => res.json())
  .then(() => {

    let items = [
      {
        id: replaceID,
        quantity: 1,
        properties: properties1
      }
    ];

    // Add second product ONLY if valid
    if (productID2 && qty2) {
      items.push({
        id: productID2,
        quantity: qty2,
        properties: properties2 || {}
      });
    }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items,
        sections,
        sections_url: window.location.pathname
      })
    });
  })
  .then(res => res.json())
  .then(data => {
    // Re-render the cart drawer with updated contents
    if (cart?.classList.contains('is-empty')) {
      cart.classList.remove('is-empty');
    }

    cart?.renderContents(data);
    console.log('Cart updated:', data);
  })
  .catch((error) => {
    console.error('Error updating cart:', error);
  })
  .finally(() => {
    if (cart?.classList.contains('is-empty')) {
      cart.classList.remove('is-empty');
    }
  });
}
// new add.js + update.js end

  // final proper JS end



  // flav n soda page video
  let video = document.querySelector('.product-card-slider__video');
  if (video) {
    video.play();
  }

  
let bottleColor1 = document.querySelectorAll('.custom-bottle-color-select-1 .color-product-variant-bottle input');
  if(bottleColor1){
  bottleColor1.forEach(input => {
      input.addEventListener('change', () => {      
          const bottleColorSelected1 = input.getAttribute('data-variant-id');
          const bottleColorName1 = input.value;
          document.querySelector('.bottle-color-id-1').value = bottleColorSelected1;
          document.querySelector('.bottle-one-color').value = bottleColorName1;
      });
    });
  }  
let bottleColor2 = document.querySelectorAll('.custom-bottle-color-select-2 .color-product-variant-bottle input');
  if(bottleColor2){
  bottleColor2.forEach(input => {
      input.addEventListener('change', () => {      
          const bottleColorSelected2 = input.getAttribute('data-variant-id');
          const bottleColorName2 = input.value;
          document.querySelector('.bottle-color-id-2').value = bottleColorSelected2;
          document.querySelector('.bottle-two-color').value = bottleColorName2;
      });
    });
  }  
let bottleColor3 = document.querySelectorAll('.custom-bottle-color-select-3 .color-product-variant-bottle input');
  if(bottleColor3){
  bottleColor3.forEach(input => {
      input.addEventListener('change', () => {      
          const bottleColorSelected3 = input.getAttribute('data-variant-id');
          const bottleColorName3 = input.value;
          document.querySelector('.bottle-color-id-3').value = bottleColorSelected3;
          document.querySelector('.bottle-three-color').value = bottleColorName3;
      });
    });
  }        


});
